import namespace from '../../smartpak/smartpak';
import saleKentico from './sale_kentico';
import swapNavTab from "./swapnavtab";

// just incase there are old references within content.
window.smartPak = window.smartPak || {};
namespace('kentico')._swapNavTab = swapNavTab;
window.smartPak.saleKentico = saleKentico;

swapNavTab();
saleKentico._bindMobileEvents();